// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-571bd7de]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:50px;margin:0 15px 15px;vertical-align:middle;-webkit-box-align:center;-ms-flex-align:center;align-items:center}h3[data-v-571bd7de]{width:100%}", ""]);
// Exports
module.exports = exports;
